import api from '../../../services/api';
import type { TaskType } from '../../../types';

export interface CreateTaskTypeRequest {
  name: string;
  color: string;
}

export interface UpdateTaskTypeRequest {
  name?: string;
  color?: string;
}

export const taskTypeService = {
  async getTaskTypes(workspace?: 'personal' | 'team', teamId?: string): Promise<TaskType[]> {
    try {
      const params: { workspace?: string; teamId?: string } = {};
      if (workspace) {
        params.workspace = workspace;
        if (teamId) {
          params.teamId = teamId;
        }
      }
      
      const response = await api.get('/task-types', { params });
      return response.data;
    } catch (error) {
      console.error('getTaskTypes API 调用失败:', error);
      throw error;
    }
  },

  async createTaskType(
    data: CreateTaskTypeRequest, 
    workspace: 'personal' | 'team' = 'personal', 
    teamId?: string
  ): Promise<TaskType> {
    const params: { workspace?: string; teamId?: string } = { workspace };
    if (teamId) {
      params.teamId = teamId;
    }
    
    const response = await api.post('/task-types', data, { params });
    return response.data;
  },

  async updateTaskType(id: string, data: UpdateTaskTypeRequest): Promise<TaskType> {
    const response = await api.put(`/task-types/${id}`, data);
    return response.data;
  },

  async deleteTaskType(id: string): Promise<void> {
    await api.delete(`/task-types/${id}`);
  }
};